import api, { API_UPLOAD_TIMEOUT_MS } from "./api";

const uploadOpts = { timeout: API_UPLOAD_TIMEOUT_MS };

export const listAdminUsers = (params = {}) => api.get("/users/admin/users/", { params });
export const createAdminStaffUser = (payload) => api.post("/users/admin/users/staff/", payload);
export const createAdminAssetManager = (payload) => api.post("/users/admin/users/asset-managers/", payload);
export const suspendUser = (id) => api.patch(`/users/admin/users/${id}/suspend/`);
export const blockUser = (id) => api.patch(`/users/admin/users/${id}/block/`);
export const reinstateUser = (id) => api.patch(`/users/admin/users/${id}/reinstate/`);
export const updateUserPermissions = (id, payload) => api.patch(`/users/admin/users/${id}/permissions/`, payload);

export const listAdminProjects = () => api.get("/admin/projects/");
export const createAdminProject = (payload) => api.post("/admin/projects/", payload);
export const updateAdminProject = (id, payload) => api.patch(`/admin/projects/${id}/`, payload);
export const presignAdminProjectOverviewPdfUpload = (payload) =>
  api.post("/admin/projects/overview-pdf/presign/", payload, uploadOpts);
export const uploadAdminProjectOverviewPdf = (formData) =>
  api.post("/admin/projects/overview-pdf/upload/", formData, uploadOpts);
export const uploadAdminProjectOverviewPdfToProject = (id, formData, config = {}) =>
  api.post(`/admin/projects/${id}/overview-pdf/upload/`, formData, {
    ...uploadOpts,
    ...config,
  });
export const getAdminProjectOverviewPdfSignedUrlByKey = (payload) =>
  api.post("/admin/projects/overview-pdf/signed/", payload, uploadOpts);
export const deleteAdminProjectOverviewPdf = (payload) =>
  api.post("/admin/projects/overview-pdf/delete/", payload, uploadOpts);
export const uploadAdminProjectHero = (id, formData) =>
  api.post(`/admin/projects/${id}/hero/upload/`, formData, uploadOpts);
export const deleteAdminProjectHero = (id) =>
  api.post(`/admin/projects/${id}/hero/delete/`, {}, uploadOpts);
export const publishAdminProjectLanding = (id, payload = { published: true }) =>
  api.post(`/admin/projects/${id}/landing/publish/`, payload);
export const pauseAdminProject = (id) => api.post(`/admin/projects/${id}/pause/`);
export const resumeAdminProject = (id) => api.post(`/admin/projects/${id}/resume/`);
export const extendAdminProject = (id, payload) => api.post(`/admin/projects/${id}/extend/`, payload);
export const cancelAdminProject = (id, body = {}) => api.post(`/admin/projects/${id}/cancel/`, body);
export const closeRedeemedAdminProject = (id) => api.post(`/admin/projects/${id}/close-redeemed/`);
export const continueRedeemedAdminProject = (id) => api.post(`/admin/projects/${id}/continue-redeemed/`);
export const listProjectShareholders = (id) => api.get(`/admin/projects/${id}/shareholders/`);
export const assignProjectManager = (id, payload) => api.post(`/admin/projects/${id}/assign-manager/`, payload);
export const unassignProjectManager = (id) => api.post(`/admin/projects/${id}/unassign-manager/`, {});

export const listAdminInvestments = () => api.get("/admin/investments/");
export const reviewAdminInvestment = (id, payload) => api.patch(`/admin/investments/${id}/review/`, payload);
/** Redemption admin review: { status, approved_shares?, admin_notes? }. */
export const reviewAdminRedemption = (id, payload) => api.patch(`/admin/redemptions/${id}/`, payload);

export const listAdminPnl = (params = {}) => api.get("/admin/pnl/", { params });
export const reviewAdminPnl = (id, payload) => api.patch(`/admin/pnl/${id}/review/`, payload);

export const listAdminKyc = () => api.get("/users/admin/kyc/");
export const reviewAdminKyc = (id, payload) => api.patch(`/users/admin/kyc/${id}/review/`, payload);

export const broadcastNotice = (payload) => api.post("/notifications/admin/notices/broadcast/", payload);
